import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "./UserContext/UserContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useUser();

  if (loading) {
    return <div>Loading...</div>; // You can show a loading spinner here
  }

  if (!user) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
